import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  variant?: "light" | "dark";
}

export const Logo = ({ className, variant = "dark" }: LogoProps) => {
  const textColor = variant === "light" ? "text-white" : "text-foreground";
  const accentColor = "text-primary";
  
  return (
    <a 
      href="/" 
      className={cn("flex items-center gap-0.5 font-body text-xl md:text-2xl font-medium tracking-tight", className)}
      aria-label="MyNewFloor.com - Home"
    >
      <span className={textColor}>my</span>
      <span className={cn("font-bold", accentColor)}>new</span>
      <span className={textColor}>floor</span>
      <span className={cn("text-sm font-normal", variant === "light" ? "text-white/80" : "text-muted-foreground")}>.com</span>
    </a>
  );
};
